export interface BreadcrumbCrumb {
  label: string
  href?: string
}

interface BreadcrumbProps {
  items: BreadcrumbCrumb[]
  className?: string
}

export default function Breadcrumb({ items, className = "" }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className={`text-sm text-gray-500 ${className}`}>
      <ol className="flex flex-wrap gap-1">
        {items.map((crumb, idx) => {
          const isLast = idx === items.length - 1
          return (
            <li key={`${crumb.label}-${idx}`} className="flex items-center gap-1">
              {idx > 0 && <span aria-hidden="true">/</span>}
              {crumb.href && !isLast ? (
                <a href={crumb.href} className="hover:underline">
                  {crumb.label}
                </a>
              ) : (
                <span aria-current={isLast ? "page" : undefined}>{crumb.label}</span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
